<template>
	<div class="tw-flex tw-h-full tw-flex-col tw-justify-between">
		<div>
			<div>
				<div
					class="tw-mb-3 tw-flex tw-items-center tw-gap-2 tw-text-[32px] tw-font-bold tw-text-gray-950"
				>
					<span>{{ $t('integrations.products-imported') }}</span>
					<div
						class="tw-flex tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-secondary-500 tw-bg-secondary-500 tw-text-white"
						style="width: 38px; height: 38px; min-width: 38px"
					>
						<AppIcon name="check" />
					</div>
				</div>
				<div class="tw-text-2xl tw-font-medium tw-text-gray-950">
					{{ $t('integrations.products-from-file-have-been-imported-into-linker') }}
				</div>
			</div>

			<div class="tw-mt-7 tw-flex tw-gap-4">
				<AppButton
					:label="$t('integrations.re-import-products')"
					size="xl"
					class="tw-rounded-full"
					type="button"
					@click="reImportProducts"
					:disabled="loading"
					:loading="loading"
					secondary
					variant="gray"
					endIcon="assets/v2/image/icons/upload.svg"
				/>

				<AppButton
					:label="$t('integrations.next-step')"
					size="xl"
					class="tw-rounded-full"
					type="button"
					endIcon="assets/v2/image/icons/arrow-narrow-right.svg"
					@click="nextStep"
					:loading="nextStepLoading"
				/>
			</div>
		</div>

<!--		<div class="tw-mt-7 tw-flex tw-justify-end">-->
<!--			<a :href="needHelpUrl" target="_blank">-->
<!--				<AppButton-->
<!--					:label="$t('integrations.need-help')"-->
<!--					variant="secondary"-->
<!--					endIcon="assets/v2/image/icons/help-circle.svg"-->
<!--					class="tw-rounded-full"-->
<!--					size="xl"-->
<!--				/>-->
<!--			</a>-->
<!--		</div>-->
	</div>
</template>

<script setup>
import { ref } from 'vue';
import { useLinkMarketplaceStore } from '@/v2/modules/integrations/stores/link-marketplace';
import { Marketplace } from '@/v2/modules/integrations/entities/marketplace';
import { Alert } from '@/v2/plugins/alert';
import { useI18n } from 'vue-i18n';
import ImportsEntity from '@/v2/modules/imports/entities/imports';
import { useRouter } from 'vue-router';

const props = defineProps({
	file: String,
});

const linkMarketplaceStore = useLinkMarketplaceStore();

const router = useRouter();
const { t } = useI18n();
const needHelpUrl = '#';
const nextStepLoading = ref(false);
const loading = ref(false);

const data = [
	{
		title: 'integrations.import-products-from-whatsapp-to-linker',
		subTitle: 'integrations.select-this-if-you-have-existing-products-in-your-catalog',
		value: '1',
	},
	{
		title: 'integrations.export-products-from-linker-to-whatsapp',
		subTitle: 'integrations.save-my-login-details-for-next-time',
		value: '2',
	},
];

const reImportProducts = async () => {
	loading.value = true;
	const values = {
		file: props.file,
	};

	try {
		await ImportsEntity.importFiles('import/products', values);
		await Marketplace.finishWizardStep(linkMarketplaceStore.currentStepData.id);
		await linkMarketplaceStore.refetchSteps();
		router.push('/v2/integrations/marketplaces');
	} catch (error) {
		Alert.error(error?.response?.data?.message);
	} finally {
		loading.value = false;
	}
};

const nextStep = async () => {
	nextStepLoading.value = true;
	try {
		await Marketplace.finishWizardStep(linkMarketplaceStore.currentStepData.id);
		await linkMarketplaceStore.refetchSteps();
	} finally {
		nextStepLoading.value = false;
	}
};
</script>

<style lang="scss" scoped></style>
